import React from 'react';
import { FieldUi } from '../Fields/FormFields/FieldUi';
import { getTranslationUi } from '../Fields/TranslationUi';
import settings from '../../config/settings';
import ToolTip from '../ToolTip/ToolTip';

const returnAsString = (value: any) => {
  if (!value) return '';

  if (typeof value === 'string') {
    return value;
  } else {
    return value[0];
  }
};

export const warn = (values: any, props: any) => {
  const { userRelatedFields } = props as { userRelatedFields: FieldUi[] };
  const warnings: { [key: string]: string } = {};
  const fieldsNameAndValidation: { [key: string]: string } = {};

  const requiredTextFields: FieldUi[] =
    userRelatedFields &&
    userRelatedFields.filter(
      (fields: FieldUi) =>
        fields.data_type === 'text' &&
        (fields.validation.max_len_fe || fields.validation.max_len)
    );

  requiredTextFields &&
    requiredTextFields.forEach(field => {
      fieldsNameAndValidation[field.name] =
        field.validation.max_len_fe || field.validation.max_len;
      if (
        values[field.name] &&
        values[field.name].length >= fieldsNameAndValidation[field.name]
      ) {

        const errorLabel = `user_profile.${field.name}.error_label`;

        warnings[field.name] = `${getTranslationUi(
          'validation_messages.max_len',
          '',
          {
            property_name: getTranslationUi(
              errorLabel,
              field.label.defaultText
            ),
            max_len: fieldsNameAndValidation[field.name],
          }
        )}`;
      }
    });

  return warnings;
};

export const validate = (values: any, props: any) => {
  const errors: { [key: string]: any } = {};
  const fieldsObjectConfig = props.initialValues?.fieldsMetadata?.fieldsObject || {};

  const { userRelatedFields } = props as { userRelatedFields: FieldUi[] };

  if (userRelatedFields && fieldsObjectConfig) {
    const phoneFields = userRelatedFields.filter(
      field =>
        field.name === fieldsObjectConfig.phone_number.name ||
        field.name === fieldsObjectConfig.calling_code.name
    );

    if (phoneFields.length) {
      const callingCode = values[fieldsObjectConfig.calling_code.name];
      if (callingCode) {
        let callingCodeRegex = userRelatedFields.filter(
          field => field.name === fieldsObjectConfig.calling_code.name
        )[0].validation.regex;

        if (typeof callingCodeRegex === 'string') {
          callingCodeRegex = new RegExp(callingCodeRegex);
        }

        if (returnAsString(callingCode) !== '' && !callingCodeRegex.test(returnAsString(callingCode))) {

          const errorLabel = `user_profile.${fieldsObjectConfig.calling_code.name}.error_label`;

          errors[fieldsObjectConfig.calling_code.name] = getTranslationUi(
            'validation_messages.incorrect_character_used',

            `${getTranslationUi(
              errorLabel,
              fieldsObjectConfig.calling_code.label.defaultText
            )} has invalid characters`
          );
        } else {

          const callingCodeRegexMatch = returnAsString(callingCode).match(callingCodeRegex) || [];

          const phoneInput = values[fieldsObjectConfig.phone_number.name];
          if (phoneInput) {
            const phoneWithCallingCode = `+${callingCodeRegexMatch[3]} ${phoneInput}`;
            let phoneRegex = userRelatedFields.filter(
              field => field.name === fieldsObjectConfig.phone_number.name
            )[0].validation.regex;

            if (typeof phoneRegex === 'string') {
              phoneRegex = new RegExp(phoneRegex);
            }

            if (returnAsString(callingCode) !== '' && !phoneRegex.test(phoneWithCallingCode)) {

              const errorLabel = `user_profile.${fieldsObjectConfig.phone_number.name}.error_label`;

              errors[fieldsObjectConfig.phone_number.name] = [
                getTranslationUi(
                  'validation_messages.incorrect_character_used',
                  `${getTranslationUi(
                    errorLabel,
                    fieldsObjectConfig.phone_number.label.defaultText
                  )} has invalid characters`
                ),
                <ToolTip
                  key={fieldsObjectConfig.phone_number.name}
                  alwaysRed={true}
                  toolTip={getTranslationUi(
                    'tooltip_messages.phone_number_incorrect_character_used',
                    `${getTranslationUi(
                      errorLabel,
                      fieldsObjectConfig.phone_number.label.defaultText
                    )} can only contain numbers, dashes, spaces and paranthesis`
                  )}
                />,
              ];
            }
          }
        }
      } else {
        if (values[fieldsObjectConfig.phone_number.name]) {

          const errorLabelPhoneNumber = `user_profile.${fieldsObjectConfig.phone_number.name}.error_label`
          const errorLabelCallingCode = `user_profile.${fieldsObjectConfig.calling_code.name}.error_label`

          errors[fieldsObjectConfig.phone_number.name] = getTranslationUi(
            'validation_messages.prop1_cannot_be_set_without_prop2',
            `${fieldsObjectConfig.calling_code.label.defaultText} should be set as well`,
            {
              property1_name: `${getTranslationUi(
                errorLabelPhoneNumber,
                fieldsObjectConfig.phone_number.label.defaultText
              )}`,
              property2_name: `${getTranslationUi(
                errorLabelCallingCode,
                fieldsObjectConfig.calling_code.label.defaultText
              )}`,
            }
          );
        }
      }
    }

    const embargoCountries = settings.embargoRestrictions.countries.split(',');
    const embargoRegions = settings.embargoRestrictions.regions.split(',');

    if (embargoCountries.includes(returnAsString(values.country) || "")) {
      errors[fieldsObjectConfig.country.name] = getTranslationUi('embargo.country_not_allowed');
    }

    if (embargoRegions.includes(returnAsString(values.state) || "")) {
      errors[fieldsObjectConfig.state.name] = getTranslationUi('embargo.region_not_allowed');
    }
  }
  return errors;
};
